import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { authFail, resetAuthError } from 'store/actions'
import { inviteApi } from 'api'
import { Formik, Form, Field } from 'formik'
import { accountsApi } from 'api'
import QRCode from 'qrcode.react'
import AuthErrorBox from 'components/Auth/AuthErrorBox'
import Logo from 'components/Logo/Logo'
import LoadingButton from 'components/ui/LoadingButton/LoadingButton'
import CheckboxItem from 'components/CheckboxItem/CheckboxItem'
import CloseIcon from '../../assets/icons/close_2.svg'
import TelIcon from '../../assets/icons/tel.svg'
import * as Yup from 'yup'
import { t } from 'translation'

const ENV = process.env.NODE_ENV
const AppURL =
  ENV === 'production'
    ? process.env.APP_URL_PRODUCTION
    : ENV === 'dev-remote'
    ? process.env.APP_URL_DEV_REMOTE
    : process.env.APP_URL_DEVELOPMENT

const sendEmailSchema = Yup.object().shape({
  email: Yup.string().email('INVALID_EMAIL').required('EMAIL_IS_REQUIRED'),
})

class InviteModal extends Component {
  state = { isLoading: false, success: false }

  closeModalHandler = (e) => {
    if (e) e.stopPropagation()

    if (this.state.isLoading) return
    this.props.resetAuthError()
    this.setState({ success: false, isLoading: false })
    this.props.toggleInviteHandler()
  }

  render() {
    const currency = this.props.licenses.currency === 'EUR' ? '€' : '$'
    const price = this.props.licenses.patientSubscriptionPrice
    const priceWithDecimals = price.toFixed(2)
    const formattedPrice =
      this.props.licenses.currency === 'EUR'
        ? priceWithDecimals.replace('.', ',')
        : priceWithDecimals
    const freeDays = this.props.licenses.freeDays
    const invitePatientDescription =
      freeDays > 0 && price > 0
        ? 'pain.INVITE_PATIENT_DESCR_FREEDAYS_PRICE'
        : price > 0 && freeDays === '0'
        ? 'pain.INVITE_PATIENT_DESCR_NOFREEDAYS_PRICE'
        : 'pain.INVITE_PATIENT_DESCR_NOPRICE'

    const QRcodeValue = `${AppURL}/signup?prescriberCode=${this.props.prescriberCode}`

    return (
      this.props.isInviteModalOpen && (
        <section className="section offset_v2_mod session_type_mod">
          <button
            className="alarm_block_remove pain_invite_mod"
            onClick={this.closeModalHandler}
          >
            <CloseIcon className="icon close_mod size_mod" />
          </button>
          <div className="section_in center_content_mod">
            <div className="invite_qr_container">
              <QRCode className="invite_qr" value={QRcodeValue} />
            </div>
            <div className="section_heading offset_mod">
              <h2 className="section_title center_mod title_step_center_mod email_pain_mod">
                {t('pain.INVITE_PATIENT')}
              </h2>
            </div>
            <div className="session_type_descr default_text">
              <p>
                {t(invitePatientDescription, {
                  currency,
                  freeDays,
                  price: formattedPrice,
                  plural: this.props.licenses.freeDays === 1 ? '' : 's',
                })}
              </p>
            </div>
            <Formik
              initialValues={{ email: '', termsCheck: false }}
              validationSchema={sendEmailSchema}
              onSubmit={async ({ email, termsCheck }) => {
                this.props.resetAuthError()
                if (!termsCheck) return this.props.authFail('INVITE_TERMS_UNCHECKED')

                this.setState({ isLoading: true })

                const { error } = await inviteApi.sendInvite({ email })

                this.setState({ isLoading: false })

                if (error) return this.props.authFail(error)

                this.setState({ success: true })
              }}
            >
              {({ errors, touched, submitForm, status, setStatus, isValid }) => (
                <Form style={{ width: '100%' }}>
                  <div className="">
                    {!this.state.success && (
                      <div className="email_invite_form_item message_box">
                        <AuthErrorBox
                          formFields={['email']}
                          formTouched={touched}
                          formErrors={errors}
                          apiResponseError={this.props.authError || ''}
                          resetApiResponseError={this.props.resetAuthError}
                          clickedSubmit={status === 'clicked'}
                          className="email_invite"
                        />
                      </div>
                    )}
                    {this.state.success && isValid ? (
                      <div className="email_invite_form_item message_box">
                        <div className="success_text form_success email_invite">
                          {t('pain.EMAIL_SUCCESSFULLY_SENT')}
                        </div>
                      </div>
                    ) : null}
                    <div className="email_invite_form_item input_field">
                      <Field
                        className={`form_field v4_mod email_invite_mod ${
                          status === 'clicked' && errors.email ? 'error' : ''
                        }`}
                        type="email"
                        name="email"
                        placeholder={t('pain.ENTER_EMAIL')}
                        disabled={this.state.isLoading || this.state.success}
                      />
                    </div>
                    <div className="form_controller login_mod size_mod">
                      <CheckboxItem
                        mod="v2_mod"
                        name="termsCheck"
                        id="invite_checkbox"
                        label={
                          <>
                            {t('pain.LEGAL_DISCLAIMER_1')}
                            <a
                              className="label_link"
                              href="https://www.music.care/conditions-pro.html"
                              target="_blank"
                              rel="noopener"
                            >
                              {t('pain.LEGAL_LINK')}
                            </a>
                            {t('pain.LEGAL_DISCLAIMER_2')}
                          </>
                        }
                        disabled={this.state.isLoading || this.state.success}
                      />
                    </div>
                    <div className="email_invite_form_item submit_btn">
                      <LoadingButton
                        noBtnBase
                        disabled={this.state.success}
                        isLoading={this.state.isLoading}
                        className="session_type_item_btn email_invite_mod"
                        onClick={() => {
                          setStatus('clicked')
                          submitForm()
                        }}
                      >
                        {t('pain.SEND')}
                      </LoadingButton>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
            <p className="invite_code">
              {t('pain.PRESCRIBER_CODE', {
                prescriberCode: this.props.prescriberCode,
              })}
            </p>
          </div>
          <div className="player_bottom_wrap">
            <div className="player_bottom v2_mod">
              <Logo modClass="bar_mod" />
            </div>
          </div>
        </section>
      )
    )
  }
}

const mapStateToProps = ({ auth: { error, attributes } }) => ({
  authError: error,
  licenses: attributes?.licenses,
  prescriberCode: attributes?.prescriberCode,
})

const willMapDispatchToProps = {
  authFail,
  resetAuthError,
}

export default connect(mapStateToProps, willMapDispatchToProps)(InviteModal)

InviteModal.propTypes = {
  authFail: PropTypes.func.isRequired,
  resetAuthError: PropTypes.func.isRequired,
  isInviteModalOpen: PropTypes.bool.isRequired,
  toggleInviteHandler: PropTypes.func.isRequired,
}
